import { selectAllSceneGroups } from '@redux/imageAssets/reducer';
import { selectAssetGroup } from '@redux/imageAssets/thunks';
import { RootState } from '@redux/reducers';
import actions from './actions';

export const setSideMapEnabled = (enabled: boolean) => (dispatch) => {
  dispatch(actions.setMapMode('idle'));
  dispatch(actions.setSideMapEnabled(enabled));
};

/**
 * Enable Anomaly Detection for a given imageId
 * @param imageId
 * @returns
 */
export const enableAnomalyDetection = (isSideMap?: boolean, imageId?: string) => (
  dispatch,
  getState
) => {
  const state = getState() as RootState;
  const isCompositionLoading = state.ImageAsset.compositionStatus === 'loading';
  const scenes = selectAllSceneGroups(state.ImageAsset);

  // Only use the first part of id
  const anomalyScene = scenes.find(
    (scene) =>
      imageId && (scene.id.includes(imageId) || scene.referenceImage.sceneId.includes(imageId))
  );

  if (!isCompositionLoading && (!imageId || anomalyScene)) {
    if (anomalyScene) dispatch(selectAssetGroup(anomalyScene.id, isSideMap));
    dispatch(actions.setAnomalyDetectionMap(true, isSideMap ? 'sideMap' : 'map'));
  }
};

export const disableAnomalyDetection = (isSideMap?: boolean) => (dispatch) => {
  dispatch(actions.setAnomalyDetectionMap(false, isSideMap ? 'sideMap' : 'map'));
};

export const resetMapViewMode = () => (dispatch) => {
  dispatch(actions.setMapViewMode('map', 'map'));
  dispatch(actions.setMapViewMode('map', 'sideMap'));
};

export const enableMapbiomas = (side: 'map' | 'sideMap' = 'map') => (dispatch) => {
  dispatch(actions.setMapViewMode('mapbiomas', side));
  dispatch(actions.setAnomalyDetectionMap(false, side));
  dispatch(actions.setTrialingPlotsEnabled(false, side));
};
